import { render, staticRenderFns } from "./c-map-item-route.vue?vue&type=template&id=2f91fdba&"
import script from "./c-map-item-route.vue?vue&type=script&lang=js&"
export * from "./c-map-item-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports